module.exports = __webpack_public_path__ + "img/975.337e0861.png";